import * as React from 'react';
import InputMask from 'react-input-mask';
import NumberFormat from 'react-number-format';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Row } from 'reactstrap';
import { FileList } from 'src/components/shared/Files/FileList';
import { DateInput } from 'src/components/shared/Input/DateInput';
import { LocationInput } from 'src/components/shared/Input/LocationInput';
import { ModalPortal } from 'src/components/shared/Modals/ModalPortal';
import { ProjectDeletionModal } from 'src/components/shared/Modals/ProjectDeletionModal';
import { deliverableItems, durationItems, functionalSkillsItems, placeItems, subtypeItems, technicalSkillsItems } from 'src/config';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IFile, IProject } from 'src/model';
import { IUpdateProjectDto } from 'src/model/dto/project-dto';
import { deleteProject, updateProject } from 'src/services';
import { isPhoneNumber } from 'src/utils/validation';
import { ProjectTypeConfig, ProjectTypeList } from '../shared/Input/ProjectTypeList';


interface IProjectEditionProps {
  project: IProject;
}

const ProjectEdition: React.SFC<
  IProjectEditionProps & IGlobalContextProps & RouteComponentProps
> = ({ context, history, project }) => {
  const [state, setState] = React.useState({
    edit: false,
    invalid: false,
    invalidProjectType :false,
    project,
    validationModalIsOpen: false,
  });
 
  const isEnded = project.meta.status === 'ended';
  const isValid =
    (!!!state.project.phone ||
      (state.project.phone && isPhoneNumber(state.project.phone))) &&
    state.project.title &&
    state.project.description;

  const toggleEdit = () => {
    setState({edit: !state.edit, invalid: false, invalidProjectType:false ,project, validationModalIsOpen: false,});
  };

  const toggleValidationModal = () =>
    setState({...state,validationModalIsOpen: !state.validationModalIsOpen,
    });

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({...state,invalid: false, project: {...state.project, [(e.target as any).name]: (e.target as any).value,}, });
  };

/* A optimiser   **********************************************/
  const handleChangeMultiFunctionalSkills = (functionalSkills: any) => {
    setState({...state, project: {...state.project, functionalSkills}, });
  };

  const handleChangeMultiTechnicalSkills = (technicalSkills: any) => {
    setState({...state, project: { ...state.project, technicalSkills}, 
    });
  };

  const handleChangeMultiSubtype = (subtype: any) => {
    setState({ ...state, project: {...state.project,subtype}, });
  };

  const handleChangeMultiPlace = (place: any) => {
    setState({...state, project: {...state.project, place}, });
  };

  const handleChangeMultiDeliverable = (deliverable: any) => {
    setState({...state, project: {...state.project,deliverable}, });
  };

  const handleChangeMultiDuration = (duration: any) => {
    setState({...state, project: {...state.project, duration}, });
  };
/**************************************************************************/
  const handleClick = (id: string) => {
    const label = ProjectTypeConfig[id].label;
    const index = state.project.projectType.indexOf(label);
    const projectType = state.project.projectType.slice();

    if (index === -1) {
      if (projectType.length < 3) {
        projectType.push(label);
        setState({
          ...state,
          project: { ...state.project, projectType },
        });
      } else {
        setState({ ...state, invalidProjectType: true });
      }
    } else {
      if (projectType.length !== 1) {
        projectType.splice(index, 1);
        setState({
          ...state,
          invalidProjectType: false,
          project: { ...state.project, projectType },
        });
      }
    }
  };

  const handleDateChange = (date: Date) => {
    setState({
      ...state,
      invalid: false,
      project: {
        ...state.project,
        startingDate: date,
      },
    });
  };

  const handleLocationUpdate = (localisation: {
    label: string;
    location: { lat: number; lng: number };
  }) => {
    setState({
      ...state,
      invalid: false,
      project: { ...state.project, localisation },
    });
  };

  const handleFilesUpdate = (files: IFile[]) => {
    setState({
      ...state,
      project: { ...state.project, files },
    });
  };

  const handleSave = async (updateProjectDto: IUpdateProjectDto) => {
    if (isValid) {
      const projectId = project && project._id;
      const updatedProject = await updateProject(projectId, updateProjectDto);
      if (updatedProject) {
        context.updateProject(updatedProject);
        setState({
          ...state,
          edit: false,
          invalid: false,
        });
      }
    } else {
      setState({
        ...state,
        invalid: true,
      });
    }
  };

  const handleProjectDeletion = async () => {
    const projectId = project && project._id;
    const deletedProject = await deleteProject(projectId);
    if (deletedProject) {
      history.push('/dashboard/');
    }
  };

  return (
    <>
      <Form className='p-5'>
        <Row>
          <Col md='12'>
            <FormGroup>
              {!state.edit ? (
                <span className='text-dark' style={{ fontSize: '32px' }}>
                  {state.project.title}
                </span>
              ) : (
                <Input
                  type='text'
                  name='title'
                  placeholder='Titre du projet'
                  disabled={!state.edit}
                  invalid={state.invalid && !!!state.project.title}
                  value={state.project.title}
                  onChange={handleChange}
                />
              )}
              <FormFeedback>
                Vous devez renseigner un titre de projet
              </FormFeedback>
            </FormGroup>
          </Col>
        </Row>
        <Row className='d-flex justify-content-between mt-2'>
          <Col md='5' xs='auto'>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-3'>
                Type de projet
              </span>
              <ProjectTypeList
                edit={state.edit}
                projectType={state.project.projectType}
                handleClick={handleClick}
              />
              <Input
                invalid={
                  state.invalidProjectType && state.project.projectType.length === 3
                }
                style={{ display: 'none' }}
              />
              <FormFeedback>
                Vous devez sélectionner 3 types maximum
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>Sous-type</span>
              <Select
                  name="subtype"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={subtypeItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={ state.project.subtype ? state.project.subtype : null}
                  onChange={handleChangeMultiSubtype}
              />
            </FormGroup>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Description
              </span>
              <Input
                type='textarea'
                name='description'
                placeholder='Description du projet'
                disabled={!state.edit}
                invalid={state.invalid && !!!state.project.description}
                value={state.project.description}
                onChange={handleChange}
                style={{ minHeight: '190px' }}
              />
              <FormFeedback>Vous devez renseigner une description</FormFeedback>
            </FormGroup>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>Téléphone</span>
              <Input
                type='text'
                name='phone'
                placeholder='Numéro de téléphone'
                disabled={!state.edit}
                invalid={
                  state.invalid &&
                  !!state.project.phone &&
                  !isPhoneNumber(state.project.phone)
                }
                value={state.project.phone ? state.project.phone : ''}
                onChange={handleChange}
                tag={InputMask}
                  mask="+3\3 9 99 99 99 99" 
                  maskChar={null} 
              />
              <FormFeedback>
                Vous devez renseigner une numéro de téléphone valide
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <FileList
                edit={state.edit}
                files={project.files}
                handleFilesUpdate={handleFilesUpdate}
                id={project._id}
                type='project'
              />
            </FormGroup>
          </Col>
          <Col md='6' xs='auto'>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Compétences fonctionelles recherchées
              </span>
              <CreatableSelect
                  name="functionalSkills"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={functionalSkillsItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={state.project.functionalSkills ? state.project.functionalSkills : null}
                  onChange={handleChangeMultiFunctionalSkills}
                  formatCreateLabel={value => `Ajouter  "${value}"`}
                  createOptionPosition='first'
              />
            </FormGroup>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Compétences techniques recherchées
              </span>
              <CreatableSelect
                  name="technicalSkills"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={technicalSkillsItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={ state.project.technicalSkills ? state.project.technicalSkills : null}
                  onChange={handleChangeMultiTechnicalSkills}
                  formatCreateLabel={value => `Ajouter  "${value}"`}
                  createOptionPosition='first'
              />
            </FormGroup>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Livrables attendus
              </span>
              <CreatableSelect
                  name="deliverable"
                  isDisabled={!state.edit}
                  classNamePrefix="form-control"
                  isMulti={true} 
                  closeMenuOnSelect = {true}
                  options={deliverableItems}
                  noOptionsMessage={() => 'Item non disponible'}
                  placeholder='saisir ou selectionner'    
                  value={state.project.deliverable ? state.project.deliverable : null}
                  onChange={handleChangeMultiDeliverable}
                  formatCreateLabel={value => `Ajouter  "${value}"`}
                  createOptionPosition='first'
              />
            </FormGroup>
            <Row className='d-flex justify-content-between'>
              <Col md='6' xs='auto'>
              <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Forfait ou régie ?
                  </span>
                  <Select
                    name="place"
                    isDisabled={!state.edit}
                    classNamePrefix="form-control"
                    isMulti={false} 
                    closeMenuOnSelect = {true}
                    options={placeItems}
                    noOptionsMessage={() => 'Item non disponible'}
                    placeholder='Selectionner'    
                    value={state.project.place }
                    onChange={handleChangeMultiPlace}
                  />
                </FormGroup>
                <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Budget min
                  </span>
                  <Input
                    type='text'
                    name='budgetMin'
                    placeholder='€'
                    disabled={!state.edit}
                    value={state.project.budgetMin ? state.project.budgetMin : ''}
                    onChange={handleChange}
                    tag={NumberFormat}
                    thousandSeparator={' '}
                    invalid={state.invalid && !!!state.project.budgetMin }
                  />
                  <FormFeedback>
                    Vous devez renseigner un budget min pour le projet
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Tarif jour min
                  </span>
                  <Input
                    type='text'
                    name='dailyPriceMin'
                    placeholder='€'
                    disabled={!state.edit}
                    value={state.project.dailyPriceMin ? state.project.dailyPriceMin : ''}
                    onChange={handleChange}
                    tag={NumberFormat}
                    thousandSeparator={' '}
                  />
                </FormGroup>
                <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Date de début souhaitée
                  </span>
                  <DateInput
                    edit={state.edit}
                    name='startingDate'
                    handleDateChange={handleDateChange}
                    value={state.project.startingDate ? new Date(state.project.startingDate) : new Date()}
                    dateFormat='dd/MM/yyyy'
                  />
                  <FormFeedback>
                    La date sélectionnée doit être postérieure à la date
                    d'aujourd'hui
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md='6' xs='auto'>
              <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>Durée</span>
                  <Select
                      name="duration"
                      isDisabled={!state.edit}
                      classNamePrefix="form-control"
                      isMulti={false} 
                      closeMenuOnSelect = {true}
                      options={durationItems}
                      noOptionsMessage={() => 'Item non disponible'}
                      placeholder='saisir ou selectionner'    
                      value={state.project.duration ? state.project.duration : null}
                      onChange={handleChangeMultiDuration}
                  />
                </FormGroup>
                <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Budget max
                  </span>
                  <Input
                    type='text'
                    name='budgetMax'
                    placeholder='€'
                    disabled={!state.edit}
                    value={state.project.budgetMax ? state.project.budgetMax : ''}
                    onChange={handleChange}
                    tag={NumberFormat}
                    thousandSeparator={' '}
                    invalid={state.invalid && !!!state.project.budgetMax }
                  />
                   <FormFeedback>
                    Vous devez renseigner un budget max pour le projet
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Tarif jour max
                  </span>
                  <Input
                    type='text'
                    name='dailyPriceMax'
                    placeholder='€'
                    disabled={!state.edit}
                    value={state.project.dailyPriceMax ? state.project.dailyPriceMax : ''}
                    onChange={handleChange}
                    tag={NumberFormat}
                    thousandSeparator={' '}
                  />
                </FormGroup>
                <FormGroup>
                  <span className='d-block font-weight-bolder mb-2'>
                    Localisation
                  </span>
                  <LocationInput
                    edit={state.edit}
                    localisation={state.project.localisation ? state.project.localisation : { label: '', location: { lat: 0, lng: 0 } }}
                    handleLocationUpdate={handleLocationUpdate}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className='d-flex justify-content-between mt-4'>
          {!state.edit ? (
            <>
              <Col md='3'>
                <Link to='/dashboard'>
                  <Button className='text-uppercase text-white bg-dark border-0'>
                    Retour aux projects
                  </Button>
                </Link>
              </Col>
              {!isEnded && (
                <Col md='3'>
                  <Button
                    className='text-uppercase text-white bg-success border-0 float-right'
                    onClick={toggleEdit}
                  >
                    Éditer
                  </Button>
                </Col>
              )}
            </>
          ) : (
            <>
              <Col md='3'>
                <Button
                  className='text-uppercase text-white bg-dark border-0'
                  onClick={toggleEdit}
                >
                  Annuler
                </Button>
              </Col>
              <Col md='4'>
                <Button
                  className='text-uppercase text-white bg-success border-0'
                  onClick={() => handleSave(state.project)}
                >
                  Sauvegarder
                </Button>
                {state.project.propositionList.length === 0 ? (
                  <Button
                    className='text-uppercase text-white bg-danger border-0 float-right'
                    onClick={toggleValidationModal}
                  >
                    Supprimer
                  </Button>
                ) : null}
              </Col>
            </>
          )}
        </Row>
      </Form>
      <ModalPortal>
        <ProjectDeletionModal
          isOpen={state.validationModalIsOpen}
          handleSave={handleProjectDeletion}
          toggleValidationModal={toggleValidationModal}
        />
      </ModalPortal>
    </>
  );
};

export const ProjectEditionWithGlobalContext = withGlobalContext(
  withRouter(ProjectEdition)
);


// WEBPACK FOOTER //
// ./src/components/Project/ProjectEdition.tsx